import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ToolbarService,GroupService, FilterService } from '@syncfusion/ej2-angular-grids';
import { DetailRowService } from '@syncfusion/ej2-angular-grids';
import { SortService } from '@syncfusion/ej2-angular-grids';
import { ConfirmationService, MessageService } from 'primeng/api';



@Component({
  selector: 'app-rules',
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.css'],
  providers: [SortService,ToolbarService,MessageService,ConfirmationService],

  
})
export class RulesComponent implements OnInit {
  @ViewChild('rulestable') rulestable:any;
  rulesList:any=[];
  showArchived:boolean=false;
 
  public toolbar: string[];
  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
      private messageService: MessageService,
    private confirmationService: ConfirmationService, 
    public router: Router,
  ) { }

  ngOnInit(): void {
    this.toolbar = ['Search'];
    this.load();
 }
 
 load(){
 
 
  const params: any = {'archived' : this.showArchived};
  this.apiService.post('kodi/ruleslistall',params).subscribe(data2 => {
    this.rulesList=data2.Result;
    this.rulestable.localeObj.currentLocale.EmptyRecord = 'Nessuna regola da visualizzare ...'; 
    this.rulestable.refresh();
  });
}



 changeArchived(){
  this.load();
}

onLoad() { 
   this.rulestable.localeObj.currentLocale.EmptyRecord = 'Caricamento in corso...'; 
}
  
apri(data){
    this.router.navigate(['/dashboard/monitors/rule-edit/update/'+data.id]);
}
qualeAzione(record){
  let color='White';
  let now=new Date();
  if(record.to){
    let d1=new Date(record.to);
    now.setDate(now.getDate() + 10);
    if(d1.getTime()<now.getTime()){
       color='Orange';
    }
    now=new Date();
    if(d1.getTime()<now.getTime()){
       color='Red';
    }
  
  }
 
  return color;
 }

 isRegolaAttiva(record: any): boolean {
  if (record?.attiva === false || record?.attiva === 0 || record?.attiva === '0') {
    return false;
  }
  return true;
 }

 statoRegolaLabel(record: any): string {
  return this.isRegolaAttiva(record) ? 'Attiva' : 'Disattiva';
 }

 statoRegolaClass(record: any): string {
  return this.isRegolaAttiva(record) ? 'regola-stato-tag--attiva' : 'regola-stato-tag--disattiva';
 }

 delete(record:any){
    this.confirmationService.confirm({
        message: 'Si conferma la cancellazione del record?',
        header: 'Conferma',
        closeOnEscape: true,
        icon: 'pi pi-exclamation-triangle',
        rejectLabel:'Annulla',
        acceptLabel:'Conferma',
        accept: () => {
          this.apiService.post('kodi/deleterule',{id:record.id}).subscribe(data2 => {
            this.messageService.add({ severity: 'warning', summary: 'ELiminato', detail: 'Record cancellato' });
            this.load();
          });
          
        },
        reject: () => {
           
        },
    });
 
  }

  
}

